@if (editMode) {
  <div></div>
}

@if (!editMode) {
  <div>
    <div>
      <div class="confirmation-text">
        {{ confirmationText }}
      </div>
      <div>
        @for (confirmationButton of confirmationButtons; track confirmationButton.uId; let i = $index) {
          <div>
            @if (confirmationButton?.type === ConfirmationType.Positive) {
              <div>
                <div
                  fxLayout="row"
                  fxLayoutAlign="start center"
                  fxLayoutGap="8px" class="confirmation-button"
                  data-confirmation-positive>
                  <div class="text">{{ confirmationButton.text }} : </div>
                  <div class="yes-button">{{ 'COMMUNICATIONS.MESSAGE-OK' | translate | uppercase }}</div>
                </div>
              </div>
            }
            @if (confirmationButton?.type !== ConfirmationType.Positive) {
              <div
                data-confirmation-negative
                >
                <div
                  fxLayout="row"
                  fxLayoutAlign="start center"
                  fxLayoutGap="8px" class="confirmation-button"
                  data-confirmation-negative>
                  <div class="text">{{ confirmationButton.text }} : </div>
                  <div class="no-button">{{ 'COMMUNICATIONS.MESSAGE-HELP' | translate | uppercase }}</div>
                </div>
              </div>
            }
          </div>
        }
      </div>
    </div>
  </div>
}
